import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { breadcrumbTokens } from '../../../tokens/components/Breadcrumb/tokens';
import { anchorCore, anchorVariants } from '../../Anchor/styles';

export interface BreadcrumbItemElementProps extends React.HTMLAttributes<HTMLElement> {
  render?: ReactNode;
  'data-testid'?: string | number;
}

const BreadcrumbItemElement = styled(
  ({ render, ...props }) => render && React.cloneElement(render, { ...props, style: undefined }),
)<BreadcrumbItemElementProps>`
  &:not(:last-child) {
    ${anchorCore}
    ${anchorVariants.link}
    &::after {
      content: ' / ';
      color: ${breadcrumbTokens.FontColorBaseDefault};
      display: inline-block;
      white-space: pre;
    }
  }
`;

export default BreadcrumbItemElement;
